module.exports = __webpack_public_path__ + "img/home-delivery_small.883023d4.webp";